import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { authLocation } from './authUrl';
import { authErrorLink, authLink } from './authRules';

type AuthLinkProps = {
  path: string;
  email?: string;
  className?: string;
  children: React.ReactNode;
};

export function AuthLink({ path, email, className = authLink, children }: AuthLinkProps) {
  const { search } = useLocation();

  return (
    <Link to={authLocation(path, search, email)} className={className}>
      {children}
    </Link>
  );
}

export function AuthErrorLink(props: Omit<AuthLinkProps, 'className'>) {
  return <AuthLink {...props} className={authErrorLink} />;
}
